import React from "react";

const EXAMPLE_COUNT = 4;
const EXAMPLE_START_MINUTES = 9 * 60;

function formatClock(totalMinutes) {
  const hour = Math.floor(totalMinutes / 60) % 24;
  const minute = totalMinutes % 60;
  return `${hour}:${String(minute).padStart(2, "0")}`;
}

function exampleStarts(durationMinutes, incrementMinutes) {
  const duration = Number(durationMinutes);
  const step = Number(incrementMinutes);
  if (!Number.isInteger(duration) || !Number.isInteger(step) || duration < 1 || step < 1) {
    return [];
  }
  if (duration % step !== 0) return [];
  return Array.from({ length: EXAMPLE_COUNT }, (_, index) => EXAMPLE_START_MINUTES + index * step);
}

const CategorySlotExample = ({ durationMinutes, bookingIncrementMinutes }) => {
  const starts = exampleStarts(durationMinutes, bookingIncrementMinutes);
  const duration = Number(durationMinutes);
  const step = Number(bookingIncrementMinutes);

  return (
    <div className="scheduling-slot-example">
      {starts.length ? (
        <>
          <p>
            Example: Each visit lasts {duration} minutes. Patients can start every {step} minutes:
          </p>
          <div className="scheduling-slot-example-times">
            {starts.map((minutes) => (
              <span key={minutes}>{formatClock(minutes)}</span>
            ))}
          </div>
        </>
      ) : (
        <p>Duration must be divisible by booking increment to generate slots.</p>
      )}
    </div>
  );
};

export default CategorySlotExample;
